import * as React from 'react';
import { ProgressBarAnimation, ProgressBarContainer, ProgressCompleteBar } from './ProgressBarWidgets';

export interface DiscreteProgressBarProps {
  /** The total number of steps to completion */
  totalSteps: number;
  /** The current number of steps */
  currentStep: number;
  /** The width of the discrete progress bar */
  width: number;
}

/** While functional, the discrete progress bar widget is disapproved by Visual Design. */
export class DiscreteProgressBarWidget_UNFINISHED extends React.PureComponent<DiscreteProgressBarProps, {}> {
  public render(): JSX.Element {
    const fractionComplete = this.props.currentStep / this.props.totalSteps;
    return (
      <ProgressBarContainer width={this.props.width}>
        <ProgressCompleteBar fractionComplete={fractionComplete}>
          {fractionComplete === 1 ? null : <ProgressBarAnimation containerWidth={this.props.width * fractionComplete} />}
        </ProgressCompleteBar>
      </ProgressBarContainer>
    );
  }
}
